export default {
  mybidding: {
    searchPlaceholder: '输入竞价项目编号或名称查询',
    biddingNo: '项目编号',
    biddingName: '项目名称',
    releaseDate: '项目发布时间',
    startTime: '竞价开始时间',
    endTime: '竞价结束时间',
    projectBudget: '项目预算',
    statusName: '竞价状态',
    addUserName: '建单人',
    ownFlag: '只看自己的单据',
    add: '新建竞价单',
    modify: '修改',
    purOfficeNo: '采购单位',
    startDate: '竞价开始时间-起',
    endDate: '竞价开始时间-止',
    biddingMode: '竞价模式',
    biddingScope: '竞价类型',
    scoreOptionsAll: {
      '1': '公开',
      '2': '本单位公开',
      '3': '邀请竞价'
    },
    operate: {
      publish: '发布',
      edit: '竞价监控',
      resultRelease: '选择中标供应商',
      finish: '审核办结',
      sendResult: '结果发布',
      showResult: '查看结果'
    },
    submit: '确认发布',
    save: '保存草稿',
    bindFileSearchPlaceholder: '输入物料编码或品名或规格查询',
    bindRuleSearchPlaceholder: '请输入供应商编号或名称查询',
    addTo: '新增竞价单',
    modifyTo: '修改竞价单',
    useConfirm: ['是否发布竞价单？']
  },
  biddingmonitoring: {
    biddingmonitoring: '竞价监控',
    supOfficeName: '供应商',
    quoteTime: '报价时间 ',
    sumAmount: '报价总额',
    biddingNo: '项目编号',
    projectBudget: '项目预算',
    signUpDeadline: '项目发布时间',
    planSignDate: '计划签约日期',
    currentRound: '当前轮次: 第{0}轮',
    tabRounds: '第{0}轮竞价（{1}）',
    hidePrice: { Y: '暗价', N: '明价' },
    btnConfig: ['按供应商', '按物料'],
    round: ['第一轮竞价', '第二轮竞价', '第三轮竞价', '第四轮竞价', '第五轮竞价'],
    goodsType: '类型',
    number: '编码',
    name: '名称',
    expirationDate: '失效日期',
    model: '型号',
    category: '所属类目',
    technologyName: '工艺',
    unit: '单位',
    currencyNo: '币种',
    qty: '数量',
    fixedPrice: '限价',
    giveUpSign: '是否放弃',
    goodsPrice: '单价(含税)',
    taxRate: '税率',
    taxIncludedAmount: '总金额',
    remarks: '供方备注',
    purchaseStandard: '采购标准',
    expectedDeliveryDate: '期望交货日期',
    goodsFileList: '附件',
    notShow: '收起',
    doShow: '展开',
    seeIp: 'IP查询',
    loginTime: '登录时间',
    loginStatus: '登录状态',
    ip: 'IP地址',
    dateRange: '登录时间',
    seeIpSearch: '查看供应商IP',
    hideAll: '收起全部数据',
    showAll: '展开全部数据',
    biddingrecord: '竞价记录',
    back: '取消',
    ifClose: '是否作废？',
    close: '作废',
    sendNotice: '发布通知'
  },
  resultsrelease: {
    resultsrelease: '选择中标供应商',
    back: '取消',
    close: '竞价作废',
    save: '保存',
    resultConfirm: '中标结果确定',
    hideAll: '收起全部数据',
    showAll: '展开全部数据',
    model: '类型',
    number: '编码',
    technologyName: '工艺',
    qty: '数量',
    unit: '单位',
    fixedPrice: '限价',
    expectedDeliveryDate: '期望交货日期',
    purchaseStandard: '采购标准',
    supOfficeName: '供应商',
    goodsPrice: '单价(含税)',
    currencyName: '币种',
    taxRate: '税率',
    taxIncludedAmount: '总金额',
    giveUpSign: '放弃报价',
    remarks: '备注',
    goodsFileList: '附件',
    action: '操作',
    finalDiscussPrice: '最终商议单价',
    finalTaxRate: '税率',
    finalTaxIncludedAmount: '最终谈判总价',
    finalRemarks: '备注',
    winBidQty: '中标数量',
    winningMethod: '中标方式',
    onlySupplierWin: '唯一供应商中标',
    multiSupplierWin: '多供应商中标',
    selectedWinSupplier: '已选中标供应商：',
    batchSelectLowestBid: '批量选择最低价中标',
    batchSelectSecondLowestAlternative: '批量选择次低价为备选',
    submitAndReview: '确定并提交审核'
  },
  biddingresult: {
    biddingresult: '竞价结果',
    supSign: '单供应商中标',
    supMore: '多供应商中标',
    biddingDetail: '中标明细',
    goodsType: '类型',
    number: '编码',
    name: '名称',
    model: '型号',
    category: '所属类目',
    technologyName: '工艺',
    unit: '单位',
    currencyName: '币种',
    qty: '数量',
    fixedPrice: '限价',
    giveUpSign: '是否放弃',
    goodsPrice: '单价(含税)',
    taxRate: '税率',
    taxIncludedAmount: '总金额',
    remarks: '供方备注',
    purchaseStandard: '采购标准',
    expectedDeliveryDate: '期望交货'
  },
  viewresults: {
    viewresults: '审核办结'
  },
  biddingauditlist: {
    searchPlaceholder: '输入竞价项目编号或名称查询',
    biddingNo: '项目编号',
    biddingName: '项目名称',
    biddingMode: '竞价模式',
    signUpDeadline: '报名截止时间',
    startTime: '竞价开始时间',
    operator: '建立人',
    supOfficeName: '报名单位',
    contactName: '报名人',
    contactPhone: '联系方式',
    signStatus: '状态'
  }
}
